const zhTW = {
  home: {
    biometric_label: "生物特徵身份驗證",
    title: "人臉反向搜尋，輕鬆實現",
    description:
      "上傳高解析度肖像，使用先進的神經網路匹配技術與全球數位檔案進行交叉比對。",
    drag_drop: "拖放您的圖片",
    file_formats: "支援 RAW、JPEG 或 PNG（最大 15MB）",
    select_file: "從系統選擇檔案",
    initiate_scan: "開始法證掃描",
    upload_hint: "請上傳圖片以繼續",
    uploading: "上傳中",
    searching: "掃描中",
    result_title: "結果",
    drop_here: "將圖片拖放至此...",
    billion_faces: "與網路上超過 10 億張臉孔比對",
    login_to_search: "登入以搜尋",
    login_required: "請登入或建立帳戶以使用此應用程式",
    not_enough_tokens: "令牌不足",
    please_wait: "請等待幾分鐘",
    leave_confirmation: "有正在進行的任務。您確定要離開嗎？",
  },
  sources: {
    section_title: "搜尋來源",
    social_media: {
      name: "社群媒體",
      description: "在各大社群網路和公開資料中進行交叉比對。",
    },
    web: {
      name: "網路",
      description: "掃描開放網路中公開可用的臉部資料。",
    },
    scammers: {
      name: "詐騙者",
      description: "與已知詐騙者身份和詐欺資料庫進行比對。",
    },
    sexual_offenders: {
      name: "性犯罪者",
      description: "與公開註冊的性犯罪者資料庫進行交叉比對。",
    },
    videos: {
      name: "影片",
      description: "從公共影片平台提取並比對臉孔。",
    },
    police_photos: {
      name: "警方照片",
      description: "與公開的警方記錄資料庫進行比較。",
    },
    news_and_blogs: {
      name: "新聞和部落格",
      description: "搜尋新聞檔案、編輯內容和部落格。",
    },
  },
  header: {
    scan: "掃描",
    history: "歷史",
    pricing: "價格",
    account: "帳戶",
    logout: "登出",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright: "© 2024 Digital Forensicist. 保留所有權利。精準身份驗證。",
    privacy: "隱私政策",
    terms: "服務條款",
    docs: "文件",
    support: "支援",
  },
  common: {
    loading: "載入中...",
    error: "錯誤",
    cancel: "取消",
    back: "返回",
  },
  errors: {
    upload_failed: "上傳失敗。請重試。",
    not_enough_tokens: "您沒有足夠的令牌來執行此搜尋。",
  },
  login: {
    disclaimer:
      "您需要一個帳戶才能使用此應用程式。我們不發送垃圾郵件，也不分享您的電子郵件。建議使用 Apple 登入以保護隱私。",
  },
  results: {
    input_source: "輸入來源",
    match_thumbnail: "比對縮圖",
    extraction_id: "提取ID",
    scan_analysis: "掃描分析",
    scan_description:
      "生物特徵逆向查詢已完成。在公共登記冊和社交索引中找到%{count}個潛在匹配項。",
    col_identity_map: "身份圖譜",
    col_verification_path: "驗證路徑",
    col_bio_match_score: "生物匹配分數",
    col_action: "操作",
    export_pdf: "匯出PDF",
    exporting: "生成中...",
    verified: "已驗證",
    details: "詳情",
    details_tooltip: "執行精確人臉比對",
    details_loading: "比對中...",
    copied: "已複製！",
    copy_url: "複製URL",
    displaying: "顯示%{count}條，共%{total}條",
  },
};

export default zhTW;
